/* jshint esnext: true */

const store = {


	/**
	 * The currently active item.
	 */
	current: 0,


	/**
	 * Initialize the store.
	 */
	init: function() {

		this.update();

	},


	/**
	 * Buy a background item.
	 */
	button_buy: function( event ) {

		event.preventDefault();

		let $item = $( this );
		let price = $item.data( 'price' );
		let key = $item.data( 'key' );

		mazes.setTileset( key );

		if ( gameData.spend( price ) ) {

			gameData.items.push( key );
			gameData.currentItem = key;
			gameData.currentBackgroundColor = tilesets[ key ][ 1 ].toString( 16 );

		}

		store.update();

	},


	/**
	 * Use a background item.
	 */
	button_use: function( event ) {

		event.preventDefault();

		let $item = $( this );
		let key = $item.data( 'key' );

		mazes.setTileset( key );

		gameData.currentItem = key;
		gameData.currentBackgroundColor = tilesets[ key ][ 1 ].toString( 16 );

		store.update();

	},


	/**
	 * Update all store properties.
	 */
	update: function() {

		$( '.store' ).html( this.render() );

		$( '.store_button_buy' ).on(
			'click',
			this.button_buy
		);

		$( '.store_button_use' ).on(
			'click',
			this.button_use
		);

	},


	/**
	 * Render the store properties.
	 */
	render: function() {

		let items = '';

		storeData.forEach(
			( value ) => {

				let label = 'Buy';
				let type = 'button';
				let [ key, price ] = value;
				let button_class = 'store_button_buy';

				if ( gameData.items.find( k => k === key ) || price <= 0 ) {
					label = 'Use';
					button_class = 'store_button_use';
				}

				if ( key === gameData.currentItem ) {
					label = 'Current';
					button_class = 'store_current';
					type = 'span';
				}

				if ( 'Buy' === label && price > gameData.money ) {
					button_class = 'store_button_disabled disabled';
				}

				items += `<li>
				<img class="icon" />
				<div>
					<h3>${tilesets[ key ][ 0 ]}</h3>
					<span class="price">${price}</span>
				</div>
				<${type} class="${button_class}" data-price="${price}" data-key="${key}">${label}</${type}>
				</li>`;

			}
		);

		return items;

	}

};